import { createSlice } from "@reduxjs/toolkit";

const initialState = () => ({});

export const upcomingListingReducer = createSlice({
  name: "upcomingListing",
  initialState,
  reducers: {
    setUpcomingListing: (state, action) => {
      state.value = {
        ...initialState,
        ...action.payload,
      };
    },
  },
});

// Action creators are generated for each case reducer function
const { actions, reducer } = upcomingListingReducer;
export const { setUpcomingListing } = actions;

export default reducer;
